// extracted by mini-css-extract-plugin
export var standaloneTable = "_1w-0";
export var standaloneTableWithBodyFill = "_1w-1";
export var withExtraHeader = "_1w-2";